import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { Http } from '@angular/http';
import { RequestBuilder } from '../classes/request-builder';
import { Observable } from 'rxjs';
import * as Enum from '../utils/enums';

@Injectable()
export class AttivitaService extends BaseService {

  constructor(http: Http) {
    super(http)
  }

  /**
   * attivita fetch single
   * @param reqBuilder 
   */
  fetchSingle(reqBuilder?: RequestBuilder): Observable<any> {
    let payload
    if (reqBuilder) {
      payload = reqBuilder
    }
    return this.doPost('attivita/fetchSingle', payload, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON)
  }

  /**
  * attivita save SAL
  * @param reqBuilder 
  */
  saveSALofAttivita(reqBuilder?: RequestBuilder): Observable<any> {
    let payload
    if (reqBuilder) {
      payload = reqBuilder
    }
    return this.doPost('SALContratto/save', payload, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON)
  }

  /**
  * attivita delete SAL
  * @param reqBuilder 
  */
 deleteSALofAttivita(reqBuilder?: RequestBuilder): Observable<any> {
  let payload
  if (reqBuilder) {
    payload = reqBuilder
  }
  return this.doPost('SALContratto/delete', payload, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON)
}

  /**
  * upload file
  * @param file file upload
  * @param salId id of sal
  * @param nomeFile name of file
  */
  uploadAllegatoSal(file: any, nomeFile: string, salId: string): Observable<any> {
    return this.doUploadSAL('allegato/saveSALContratto', file, Enum.CONTENT_TYPE_ENUM.APPLICATION_OCTET_STREAM, salId, nomeFile)
  }
}
